/* eslint-disable arrow-body-style */
import React from 'react';
import { SearchResults } from '@src/common/FilterPanelPage/results/SearchResults';
import { riskScoresId } from '../types';
import { useRiskScoreResultsStore } from '../mothership/riskScoresResults.state';
import { Results } from './resultsComponents/Results';

export const RiskScoresResults = () => {
  const status = useRiskScoreResultsStore((state) => state.resultStatus);

  return (
    <SearchResults
      id={riskScoresId}
      status={status}
      iconPending="filter"
      SuccessComp={<Results id={riskScoresId} />}
    />
  );
};
